import { Classes } from "@blueprintjs/core";
import React from "react";
import styled from "styled-components";

import { HexToastProps } from "../components/common/Toasts";
import { HexKeyCombo } from "../hex-components/HexKeyCombo";

// Blueprint has some aggressive styles when it comes to key combos in buttons
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const StyledHexKeyCombo = styled(HexKeyCombo)`
  margin-left: 5px;

  &&& > .${Classes.ICON} {
    margin: 0px 3px 0px 0px;
  }
`;

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const Undo = styled.span`
  color: ${({ theme }) => theme.fontColor.MUTED};
`;

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const UndoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const UndoElement = (
  <UndoWrapper>
    <Undo>Undo</Undo>
    <StyledHexKeyCombo combo="mod + z" />
  </UndoWrapper>
);

interface Options {
  message: string;
  undoable: boolean;
  onUndoClick?: () => void;
}

export const makeUndoToast = ({
  message,
  onUndoClick,
  undoable,
}: Options): HexToastProps => ({
  message,
  position: "bottom-right",
  action: undoable
    ? {
        text: UndoElement,
        onClick: onUndoClick,
      }
    : undefined,
});
